export default "__VITE_ASSET__Cm10KI3p__"